import DAO from "../DAO/DAO";

export default {
	install(Vue) {
		Vue.prototype.$DAO = DAO;
	}
};
